import {
  DkimStatus,
  DnsRecordCheckStatus,
  DnsRecordKind,
  MailFromDomainStatus,
  teamEmailAddressSchema,
} from "@redotech/redo-model/email/domain-verification";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const dnsRecordCheckSchema = z.object({
  status: createEnum(DnsRecordCheckStatus),
  lastCheckedAt: z.date().nullish(),
  lastChangedAt: z.date().nullish(),
  observed: z.string().nullish(),
});

const dnsRecordStatusMapSchema = z.object({
  [DnsRecordKind.DKIM]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.SPF]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.DMARC]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.MAIL_FROM_MX]: dnsRecordCheckSchema.nullish(),
  [DnsRecordKind.MAIL_FROM_SPF]: dnsRecordCheckSchema.nullish(),
});

/**
 * @deprecated This endpoint assumes one domain per team, which is no longer true.
 * Use `getTeamEmailAddresses` and `getEmailDomains` instead.
 *
 * TODO: Remove this endpoint once we stop getting requests to it. Probably around May 5.
 */
export const getCustomDomain = {
  name: "getCustomDomain" as const,
  input: z.object({}),
  output: z.object({
    enabled: z.boolean(),
    domain: z.string().nullish(),
    mailFromDomain: z.string().nullish(),
    mailFromDomainStatus: createEnum(MailFromDomainStatus).nullish(),
    addresses: z.array(teamEmailAddressSchema).nullish(),
    defaultFromAddressId: z.string().nullish(),
    defaultReplyToAddressId: z.string().nullish(),
    dkimStatus: createEnum(DkimStatus).nullish(),
    warmingEnabled: z.boolean().nullish(),
    dnsRecordStatus: dnsRecordStatusMapSchema.nullish(),
    dnsLastVerifiedAt: z.date().nullish(),
  }),
};
